import React from 'react'

import './Footer.scss'

const Footer = () => {
    return (
        <section id="footer">
            Made with ❤ using React
        </section>
    )
}

export default Footer;
